// image-zoom.js - Place in assets folder

document.addEventListener('DOMContentLoaded', function() {
  initImageZoom();
  
  // Re-initialize when slider changes
  const slider = document.querySelector('#Slider-Gallery-' + document.querySelector('[id^="Slider-Gallery-"]')?.id.split('-').pop());
  if (slider) {
    const observer = new MutationObserver(() => {
      initImageZoom();
    });
    observer.observe(slider, { childList: true, subtree: true, attributes: true });
  }
});

function initImageZoom() {
  // Only run on desktop
  if (window.innerWidth < 990) return;
  
  const mediaItems = document.querySelectorAll('.product__media-item:not(.zoom-initialized)');
  
  mediaItems.forEach(function(item) {
    const mediaWrapper = item.querySelector('.product__modal-opener, .deferred-media');
    if (!mediaWrapper) return;
    
    const img = mediaWrapper.querySelector('img');
    if (!img) return;
    
    item.classList.add('zoom-initialized');
    
    // Create zoom container
    const zoomContainer = document.createElement('div');
    zoomContainer.className = 'image-zoom-container';
    zoomContainer.style.cssText = 'position: fixed; width: 400px; height: 400px; border: 1px solid #ddd; background: white; display: none; overflow: hidden; z-index: 9999; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-radius: 4px; pointer-events: none;';
    
    const zoomedImg = document.createElement('img');
    zoomedImg.style.cssText = 'position: absolute; max-width: none;';
    
    // Get high resolution image URL
    const imgSrc = img.src;
    const highResSrc = imgSrc.replace(/(\.[^.]+)(\?|$)/, '_2048x$1$2');
    zoomedImg.src = highResSrc;
    
    zoomContainer.appendChild(zoomedImg);
    document.body.appendChild(zoomContainer);
    
    // Zoom logic
    let scale = 2; // Zoom level
    const zoomSize = 400; // Width and height of zoom container

    function handleMouseMove(e) {
      const rect = img.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      // Check if mouse is within image bounds
      if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
        zoomContainer.style.display = 'none';
        return;
      }
      
      // Calculate position for zoom container
      let zoomLeft = e.clientX + 15;
      let zoomTop = e.clientY + 15;
      
      // Check if zoom container would go off screen on the right
      if (zoomLeft + zoomSize > window.innerWidth) {
        zoomLeft = e.clientX - zoomSize - 15; // Position to the left of cursor
      }
      
      // Check if zoom container would go off screen at the bottom
      if (zoomTop + zoomSize > window.innerHeight) {
        zoomTop = e.clientY - zoomSize - 15; // Position above cursor
      }
      
      // Position zoom container
      zoomContainer.style.left = zoomLeft + 'px';
      zoomContainer.style.top = zoomTop + 'px';
      zoomContainer.style.display = 'block';
      
      // Calculate the position in the original image
      const xPercent = (x / rect.width);
      const yPercent = (y / rect.height);
      
      // Calculate the visible area in the zoomed image
      const imgWidth = rect.width * scale;
      const imgHeight = rect.height * scale;
      
      // Calculate the ideal centered position
      let left = -(xPercent * imgWidth - zoomSize / 2);
      let top = -(yPercent * imgHeight - zoomSize / 2);
      
      // Constrain to image boundaries to avoid white space
      left = Math.max(Math.min(left, 0), -(imgWidth - zoomSize));
      top = Math.max(Math.min(top, 0), -(imgHeight - zoomSize));
      
      zoomedImg.style.width = imgWidth + 'px';
      zoomedImg.style.height = imgHeight + 'px';
      zoomedImg.style.left = left + 'px';
      zoomedImg.style.top = top + 'px';
      
      // Update cursor
      img.style.cursor = 'crosshair';
    }
    
    function handleMouseEnter() {
      zoomContainer.style.display = 'block';
    }
    
    function handleMouseLeave() {
      zoomContainer.style.display = 'none';
      img.style.cursor = '';
    }
    
    // Add event listeners
    mediaWrapper.addEventListener('mouseenter', handleMouseEnter);
    mediaWrapper.addEventListener('mousemove', handleMouseMove);
    mediaWrapper.addEventListener('mouseleave', handleMouseLeave);
  });
}

// Responsive handling
window.addEventListener('resize', function() {
  const zoomContainers = document.querySelectorAll('.image-zoom-container');
  if (window.innerWidth < 990) {
    zoomContainers.forEach(c => c.style.display = 'none');
  }
});